// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"91aa94d5","977":"1b5ca05d"}[chunkId] + ".chunk.js";
};